import { createGlobalStyle } from 'styled-components'

// MFS 단가관리 표 공통: 헤더/셀 볼드 해제(400) + 가운데 정렬 헤더(center-col). (Figma/HTML 목업 기준)
export const PricingTableStyle = createGlobalStyle`
  .pricing-grid .ag-header-cell-text { font-weight: 400 !important; }
  .pricing-grid .center-col .ag-header-cell-label { justify-content: center; }
  /* GridTableV2 기본 .ag-row(min-height 36·height auto)를 목업 행 높이 52px로 (rowHeight=52와 함께) */
  .pricing-grid .ag-row { min-height: 52px !important; height: 52px !important; }

  /* 액션 컬럼 좌측 세로 구분선 (기본단가 수정일 ↔ 변경 이력) — 헤더+셀 풀하이트 */
  .pricing-grid .col-divider { border-left: 1px solid #e6e6e6 !important; }

  /* 탭 — HTML 목업 정합: 16px, 활성 파란색(#245EFF) 텍스트+밑줄, 비활성 회색, 하단 구분선 */
  .pricing-tabs { border-bottom: 1px solid #ebebeb; }
  .pricing-tabs [role='tab'] span { font-size: 16px !important; }
  .pricing-tabs [role='tab'][aria-selected='true'] span { color: #245eff !important; }
  .pricing-tabs [role='tab']:not([aria-selected='true']) span { color: #8a8a8a !important; }
  .pricing-tabs > div:last-child { background-color: #245eff !important; }
`
